;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"427ee891dd2342cc4abad6bbb04a2b8fe27c258e"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.18";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/custom\",\"regex\":\"^/([^/]+)/custom$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/rooms/:roomName\",\"regex\":\"^/([^/]+)/rooms/([^/]+)$\",\"paramNames\":[\"locale\",\"roomName\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/sign-in\",\"regex\":\"^/([^/]+)/sign-in$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";import * as Sentry from '@sentry/nextjs';

import {
  SENTRY_DSN,
  sentryBeforeSend,
  sentryEnvironment,
  sentryRelease,
  sentryTags,
  sentryTracesSampleRate,
} from '@/lib/sentry-config';

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: Boolean(SENTRY_DSN),
  environment: sentryEnvironment(),
  release: sentryRelease(),
  tracesSampleRate: sentryTracesSampleRate(),
  beforeSend: sentryBeforeSend,
  initialScope: {
    tags: sentryTags(),
  },
  integrations: [Sentry.replayIntegration()],
  // Session replay: sample a small baseline; always capture sessions with errors.
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
